(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-sec"] && !Shopify.designMode) return;
  try {
    
// Select all accordion headers
const accordionHeaders = document.querySelectorAll('.accordion-header');

// Add event listener for each accordion header
accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        const plusMinus = header.querySelector('.accordion-plus');

        // Toggle display of the content
        content.style.display = content.style.display === 'block' ? 'none' : 'block';

        // Toggle the plus/minus sign
        if (content.style.display === 'block') {
            plusMinus.textContent = '-';
        } else {
            plusMinus.textContent = '+';
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
